import {defineStore} from 'pinia'
import {computed} from "vue";

export const PredictionsStore = defineStore('PredictionsStore', {
    state: () => ({
        period: 'today',
        today: null,
        weekly: null,
        monthly: null,
        yearly: null
    }),
    
    actions: {
        setPeriod(period) {
            this.period = period;
        }
    }
});
